"use client";

import HyperDX from "@hyperdx/browser";
import { useEffect } from "react";
import { checkAndSetAnalyticsFromURL, shouldSkipAnalytics } from "@/app/utils/analytics";

interface AnalyticsCheckProps {
  analyticsEnabled: boolean;
}

/**
 * Client component that checks for the skipanalytics parameter and
 * initializes HyperDX if analytics are enabled and not skipped
 */
export default function AnalyticsCheck({ analyticsEnabled }: AnalyticsCheckProps) {
  useEffect(() => {
    // First check if the skipanalytics parameter is in the URL
    checkAndSetAnalyticsFromURL();
    
    // Initialize HyperDX only if analytics are enabled and not skipped
    if (analyticsEnabled && !shouldSkipAnalytics()) {
      HyperDX.init({
        apiKey: "039869c3-fc44-4000-93f9-7f84fb668b22",
        service: "bhumiboss-fe",
        tracePropagationTargets: [/(www.home-saathi.com|www.bhumiboss.com)/i],
        consoleCapture: false,
        advancedNetworkCapture: false,
        disableReplay: true
      });
    }
  }, [analyticsEnabled]);

  // This component doesn't render anything
  return null;
} 